import { FormControlValidator } from '../use-form-control';
import { Utils } from '@ncss/models';
export function PasswordValidator(): FormControlValidator {
  return (val) => {
    if (val && val.length && val.length < 8) {
      return {
        valid: false,
        errors: [{ msg: 'Passwords must be at least 8 characters long.' }],
      };
    }
    return { valid: true };
  };
}

export function EmailValidator(required = true): FormControlValidator {
  return (email) => {
    if (!email && !required) {
      return { valid: true };
    }
    if (Utils.IsValidEmail(email)) {
      return { valid: true };
    } else {
      return { valid: false, errors: [{ msg: 'Please enter a valid email' }] };
    }
  };
}
